(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./item.less", "../icon", "../_mixins/vantTouch"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./item.less"), require("../icon"), require("../_mixins/vantTouch"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.item, global.icon, global.vantTouch);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _item, _icon, _vantTouch) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _icon = _interopRequireDefault(_icon);
  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        class: ['nx-field-item', _vm.disabled ? 'is-disabled' : '', !_vm.disabled && _vm.comClickable ? 'is-clickable' : '', _vm.border ? 'is-border' : ''],
        on: {
          "click": _vm.onClick,
          "touchend": _vm.onTouchEnd,
          "touchmove": _vm.onTouchMove,
          "touchstart": _vm.onTouchStart
        }
      }, [_c('div', {
        class: ['nx-field-item__container', 'nx-field-item__container--' + _vm.type, _vm.$slots.children ? 'multi-line' : '']
      }, [_c('div', {
        staticClass: "nx-field-item__content",
        attrs: {
          "tabindex": _vm.ariaInsideFieldFocus.all ? '1' : 'undefined',
          "aria-label": _vm.ariaInsideLabelContent.all
        }
      }, [_vm.$slots.left || _vm.$slots.icon || _vm.title ? _c('div', {
        ref: "fieldItemLeft",
        staticClass: "nx-field-item__left",
        style: {
          'min-width': _vm.leftWidth + "px"
        },
        attrs: {
          "tabindex": _vm.ariaInsideFieldFocus.left && _vm.title ? '1' : 'undefined',
          "aria-label": _vm.ariaInsideLabelContent.left || _vm.title
        }
      }, [_vm.$slots.left ? [_vm._t("left")] : [_vm.$slots.icon ? _c('span', {
        staticClass: "nx-field-item__icon",
        attrs: {
          "aria-hidden": "true"
        }
      }, [_vm._t("icon")], 2) : _vm._e(), _vm.title ? _c('label', {
        class: ['nx-field-item__title', 'nx-field-item__title--' + _vm.type, _vm.nowrap ? '' : 'is-wrap'],
        attrs: {
          "aria-hidden": "true"
        },
        domProps: {
          "textContent": _vm._s(_vm.title)
        }
      }) : _vm._e()]], 2) : _vm._e(), _c('div', {
        staticClass: "nx-field-item__middle",
        attrs: {
          "tabindex": _vm.ariaInsideFieldFocus.middle ? '1' : 'undefined',
          "aria-label": _vm.ariaInsideLabelContent.middle
        }
      }, [_vm._t("default", [_vm.content ? _c('div', [_vm._v(_vm._s(_vm.content))]) : _vm.placeholder ? _c('div', {
        staticClass: "nx-field-item__placeholder",
        domProps: {
          "textContent": _vm._s(_vm.placeholder)
        }
      }) : _vm._e()]), _vm.$slots.children ? _c('div', {
        staticClass: "nx-field-item__children",
        attrs: {
          "tabindex": _vm.ariaInsideFieldFocus.children ? '1' : 'undefined'
        }
      }, [_vm._t("children")], 2) : _vm._e()], 2), _vm.arrow || _vm.extra || _vm.$slots.right ? _c('div', {
        class: ['nx-field-item__right', 'nx-field-item__right--' + _vm.type],
        attrs: {
          "tabindex": _vm.ariaInsideFieldFocus.right ? '1' : 'undefined',
          "aria-label": _vm.ariaInsideLabelContent.right
        }
      }, [_vm.extra || _vm.$slots.right ? _vm._t("right", [_vm._v(_vm._s(_vm.extra))]) : _vm._e(), _vm.arrow ? _c('nx-icon', {
        staticClass: "arrow",
        attrs: {
          "name": "list-arrow-os4",
          "aria-hidden": "true"
        }
      }) : _vm._e()], 2) : _vm._e()]), _vm.$slots.brief ? _c('div', {
        staticClass: "nx-field-item__brief",
        attrs: {
          "tabindex": _vm.ariaInsideFieldFocus.brief ? '1' : 'undefined'
        }
      }, [_vm._t("brief")], 2) : _vm._e(), _vm._t("ariaInputLength")], 2), _vm.$slots.error ? _c('div', {
        staticClass: "nx-field-item__error",
        attrs: {
          "tabindex": _vm.ariaInsideFieldFocus.brief ? '1' : 'undefined'
        }
      }, [_vm._t("error")], 2) : _vm._e(), _vm.$slots.extraBottom ? _c('div', {
        staticClass: "nx-field-item__extra--bottom",
        attrs: {
          "tabindex": _vm.ariaInsideFieldFocus.extraBottom ? '1' : 'undefined'
        }
      }, [_vm._t("extraBottom")], 2) : _vm._e(), _vm.$slots.textareaBottom ? _c('div', {
        class: ['nx-field-item__textarea--bottom', 'nx-field-item__textarea--bottom--' + _vm.type],
        attrs: {
          "tabindex": _vm.ariaInsideFieldFocus.textareaBottom ? '1' : 'undefined',
          "aria-label": _vm.ariaInsideLabelContent.textareaBottom
        }
      }, [_vm._t("textareaBottom")], 2) : _vm._e()]);
    },
    name: 'nx-field-item',
    components: (0, _defineProperty2.default)({}, _icon.default.name, _icon.default),
    mixins: [_vantTouch.TouchMixin],
    props: {
      type: {
        type: String,
        default: 'normal'
      },
      title: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      content: {
        type: String,
        default: ''
      },
      extra: {
        type: String,
        default: ''
      },
      nowrap: {
        type: Boolean,
        default: true
      },
      arrow: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      clickable: {
        type: Boolean,
        default: true
      },
      border: {
        type: Boolean,
        default: false
      },
      subtitle: {
        type: String,
        default: ''
      },
      leftMinWidth: {
        type: Boolean,
        default: false
      },
      ariaLabelContent: {
        type: Object,
        default: function _default() {
          return {
            all: '',
            left: '',
            middle: '',
            right: '',
            brief: '',
            textareaBottom: '',
            extraBottom: ''
          };
        }
      },
      ariaFieldFocus: {
        type: Object,
        default: function _default() {
          return {
            all: true,
            left: false,
            middle: false,
            right: false,
            children: false,
            brief: false,
            extraBottom: false
          };
        }
      }
    },
    computed: {
      ariaInsideFieldFocus: function ariaInsideFieldFocus() {
        var _this$ariaFieldFocus = this.ariaFieldFocus,
            _this$ariaFieldFocus$ = _this$ariaFieldFocus.all,
            all = _this$ariaFieldFocus$ === void 0 ? true : _this$ariaFieldFocus$,
            _this$ariaFieldFocus$2 = _this$ariaFieldFocus.left,
            left = _this$ariaFieldFocus$2 === void 0 ? false : _this$ariaFieldFocus$2,
            _this$ariaFieldFocus$3 = _this$ariaFieldFocus.middle,
            middle = _this$ariaFieldFocus$3 === void 0 ? false : _this$ariaFieldFocus$3,
            _this$ariaFieldFocus$4 = _this$ariaFieldFocus.right,
            right = _this$ariaFieldFocus$4 === void 0 ? false : _this$ariaFieldFocus$4,
            _this$ariaFieldFocus$5 = _this$ariaFieldFocus.children,
            children = _this$ariaFieldFocus$5 === void 0 ? false : _this$ariaFieldFocus$5,
            _this$ariaFieldFocus$6 = _this$ariaFieldFocus.brief,
            brief = _this$ariaFieldFocus$6 === void 0 ? false : _this$ariaFieldFocus$6,
            _this$ariaFieldFocus$7 = _this$ariaFieldFocus.extraBottom,
            extraBottom = _this$ariaFieldFocus$7 === void 0 ? false : _this$ariaFieldFocus$7,
            _this$ariaFieldFocus$8 = _this$ariaFieldFocus.textareaBottom,
            textareaBottom = _this$ariaFieldFocus$8 === void 0 ? false : _this$ariaFieldFocus$8;
        return {
          all: all,
          left: left,
          middle: middle,
          right: right,
          children: children,
          brief: brief,
          extraBottom: extraBottom,
          textareaBottom: textareaBottom
        };
      },
      ariaInsideLabelContent: function ariaInsideLabelContent() {
        var _this$ariaLabelConten = this.ariaLabelContent,
            _this$ariaLabelConten2 = _this$ariaLabelConten.all,
            all = _this$ariaLabelConten2 === void 0 ? '' : _this$ariaLabelConten2,
            _this$ariaLabelConten3 = _this$ariaLabelConten.left,
            left = _this$ariaLabelConten3 === void 0 ? '' : _this$ariaLabelConten3,
            _this$ariaLabelConten4 = _this$ariaLabelConten.middle,
            middle = _this$ariaLabelConten4 === void 0 ? '' : _this$ariaLabelConten4,
            _this$ariaLabelConten5 = _this$ariaLabelConten.right,
            right = _this$ariaLabelConten5 === void 0 ? '' : _this$ariaLabelConten5,
            _this$ariaLabelConten6 = _this$ariaLabelConten.brief,
            brief = _this$ariaLabelConten6 === void 0 ? '' : _this$ariaLabelConten6,
            _this$ariaLabelConten7 = _this$ariaLabelConten.extraBottom,
            extraBottom = _this$ariaLabelConten7 === void 0 ? '' : _this$ariaLabelConten7,
            _this$ariaLabelConten8 = _this$ariaLabelConten.textareaBottom,
            textareaBottom = _this$ariaLabelConten8 === void 0 ? '' : _this$ariaLabelConten8;
        return {
          all: all,
          left: left,
          middle: middle,
          right: right,
          brief: brief,
          extraBottom: extraBottom,
          textareaBottom: textareaBottom
        };
      },
      leftWidth: function leftWidth() {
        return this.rootField && this.rootField.maxLeftWidth;
      },
      comClickable: function comClickable() {
        var fieldClickable = this.rootField && this.rootField.clickable;
        if (fieldClickable === undefined) return this.clickable;else return fieldClickable;
      }
    },
    inject: {
      rootField: {
        from: 'rootField',
        default: function _default() {
          return undefined;
        }
      }
    },
    data: function data() {
      return {};
    },
    created: function created() {},
    mounted: function mounted() {
      this.rootField && this.rootField.$_add(this);
    },
    destroyed: function destroyed() {
      this.rootField && this.rootField.$_remove(this);
    },
    methods: {
      onClick: function onClick(e) {
        if (!this.disabled) {
          this.$emit('click', e);
        }
      },
      onTouchEnd: function onTouchEnd(e) {
        var isMove = this.offsetX + this.offsetY < 10;
        if (isMove) this.$emit('touchendFix', e);
      },
      onTouchMove: function onTouchMove(e) {
        this.touchMove(e);
      },
      onTouchStart: function onTouchStart(e) {
        this.touchStart(e);
      }
    }
  };
  _exports.default = _default2;
});